import { render, staticRenderFns } from "./hbtdyszyxy.vue?vue&type=template&id=35f84bf4&scoped=true&"
import script from "./hbtdyszyxy.vue?vue&type=script&lang=js&"
export * from "./hbtdyszyxy.vue?vue&type=script&lang=js&"
import style0 from "./hbtdyszyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./hbtdyszyxy.vue?vue&type=style&index=1&id=35f84bf4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f84bf4",
  null
  
)

export default component.exports